import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = (theme: ExactTheme) =>
  css({
    position: "absolute",
    inset: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    zIndex: theme.zIndices.loadingOverlays,
  });

export const backDrop = css({
  opacity: 0.75,
  position: "absolute",
  backgroundColor: "white",
  inset: 0,
});

export const inner = css({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

export const title = css({
  marginTop: 20,
});
